import { render, staticRenderFns } from "./queryList.vue?vue&type=template&id=226b6666&scoped=true"
import script from "./queryList.vue?vue&type=script&lang=js"
export * from "./queryList.vue?vue&type=script&lang=js"
import style0 from "./queryList.vue?vue&type=style&index=0&id=226b6666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b6666",
  null
  
)

export default component.exports